import { findDOMNode } from 'react-dom';
import { TimelineLite, Power4 } from 'gsap';
import globals from '../../globals';

export default {

    handleMouseEnter(element) {
        let node = findDOMNode(element),
            title = node.querySelector('.title'),
            tl = new TimelineLite();

        if (title) {
			tl.to(title, 0.3, {opacity: 1});
			tl.fromTo(title.querySelector('.heading'), 0.2, {scale: 1.6}, {scale: 1}, 0);
		}
    },

    handleMouseLeave(element) {
        let node = findDOMNode(element),
            title = node.querySelector('.title'),
            tl = new TimelineLite();

        if (title) {
			tl.to(title.querySelector('.heading'), 0.2, {scale: 1.6});
			tl.to(title, 0.3, {opacity: 0}, 0);
		}
    },

    handleChange(container, activePos, nextPos, pointer, onComplete) {
        let tl = new TimelineLite(),
			tlPointer = new TimelineLite(),
            colorPrimary = globals.getCssVar('--color-primary'),
            colorDarkGrey = globals.getCssVar('--color-darkgrey'),
            activeItem = document.getElementById('work-item-' + activePos),
            activeBtn = document.getElementById('work-btn-' + activePos),
            nextItem = document.getElementById('work-item-' + nextPos),
            nextBtn = document.getElementById('work-btn-' + nextPos);

		tlPointer.to(pointer, 0.2, {x: 15, ease: Power4.easeInOut});
		tlPointer.to(pointer, 0.1, {scale: 0.9}, '-=0.10');
		tlPointer.to(pointer, 0.1, {scale: 1});
		tlPointer.to(pointer, 0.2, {x: 0, ease: Power4.easeOut});

        tl.addLabel('moveBtn');
        tl.to(activeBtn, 0.2, {scale: 0.2, yoyo: true, repeat: 1}, 'moveBtn');
        tl.to(activeBtn, 0.2, {backgroundColor: colorDarkGrey}, 'moveBtn');
        tl.to(nextBtn, 0.2, {backgroundColor: colorPrimary}, 'moveBtn+=0.2');
        tl.to(nextBtn, 0.2, {scale: 2, yoyo: true, repeat: 1}, 'moveBtn+=0.2');

        tl.addLabel('hideActive', 0);
        tl.set(activeItem.querySelector('.title'), {visibility: 'hidden'}, 'hideActive');
        tl.to(activeItem.querySelector('.bg-cover'), 0.2, {opacity: 1}, 'hideActive');
        tl.to(activeItem.querySelectorAll('.imagery .dot'), 0.1, {opacity: 0}, 'hideActive');
        tl.to(activeItem.querySelectorAll('.wiper-horizontal'), 0.3, {height: '49.5%', ease: Power4.easeOut}, 'hideActive');
        tl.to(activeItem.querySelectorAll('.wiper'), 0.3, {width: '50.05%', ease: Power4.easeOut}, '-=0.25');

        tl.addLabel('prepNext');
        tl.set(nextItem.querySelector('.bg-cover'), {opacity: 1}, 'prepNext');
        tl.set(nextItem.querySelectorAll('.imagery .dot'), {opacity: 0}, 'prepNext');
        tl.set(nextItem.querySelectorAll('.wiper-horizontal'), {height: '50%'}, 'prepNext');
        tl.set(nextItem.querySelectorAll('.wiper'), {width: '50.05%'}, 'prepNext');

        tl.set(activeItem, {display: 'none', delay: 0.2});
        tl.set(activeItem.querySelector('.title'), {visibility: 'visible'});
        tl.set(nextItem, {display: 'flex'});

        tl.addLabel('showNext');
        tl.to(nextItem.querySelectorAll('.wiper-horizontal'), 0.3, {height: 0, ease: Power4.easeOut}, 'showNext');
        tl.to(nextItem.querySelectorAll('.wiper'), 0.3, {width: 0, ease: Power4.easeOut}, 'showNext');
        tl.to(nextItem.querySelectorAll('.imagery .dot'), 0.1, {opacity: 1}, 'showNext');
        tl.to(nextItem.querySelector('.bg-cover'), 0.3, {opacity: 0}, 'showNext+=0.1');

        tl.add(() => {
            onComplete();
        })
    }

};


// WEBPACK FOOTER //
// ./src/js/views/Work/animations.js